import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { AiScrubBatchListResponse } from '../../models';

export const getAiScrubBatchList: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<AiScrubBatchListResponse> = (fetchContext, awardId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/ai-scrub-batches`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  .then((response) => responseErrorHandler<AiScrubBatchListResponse>(fetchContext.errorStore, response, 'list AI scrub batches'));
